
import Vue from 'vue';
import SchedulerService from '../services/scheduler.service';
import {eventBus} from "@/services/event-bus";
import MaterialCard from "../views/base/MaterialCard.vue";

export default Vue.extend({
  props: ['value', 'dialog'],
  components: {
    baseMaterialCard: MaterialCard,
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('month'),
          value: 'month',
          order: 'desc'
        },
        {
          text: this.$t('activity'),
          value: 'activity',
        },
        {
          text: this.$t('status'),
          value: 'status',
        },
        {
          text: this.$t('count'),
          value: 'count',
        },
      ],
      elements: [],
      loading: false,
    }
  },
  computed: {
    title(): string {
      return `${this.value.name} ${this.value.surname}`;
    },
  },
  watch: {
    dialog: function (newVal, oldVal) { // watch it
      if (newVal) {
        this.loadSummary();
      }
    }
  },
  methods: {
    loadSummary() {
      this.loading = true;
      SchedulerService.loadSummary(this.value.id).then(this.onLoadSummery).catch(e => eventBus.$emit('error', e.message));
    },
    onLoadSummery(v: any) {
      // eslint-disable-next-line no-console
      console.log(v);
      this.elements = v;
      this.loading = false;
    },
    hideMenu() {
      this.$emit('close');
    },
  },
});
